import { Component, createRef } from 'react';
import SakuraOrbit from './SakuraOrbit';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import SakuraSep from './SakuraSep';
import Crown from './Crown';

const rpc = new DataRPC();

/* ── Palette ──────────────────────────────────────────────── */
export const PALETTE = [
    ['#e12454', '#223a66'],
    ['#2c5f7a', '#223a66'],
    ['#e85d04', '#c9932a'],
    ['#6b3f8c', '#223a66'],
    ['#1a7a6b', '#2c5f7a'],
    ['#e12454', '#6b3f8c'],
    ['#c9932a', '#e12454'],
    ['#223a66', '#1a7a6b'],
];

/* ── Photo & Video pools (shared with TeamsDetails) ──────── */
export const PHOTO_POOL = [
    { src: 'next-event-1.jpg',           caption: 'Lễ Khai Mạc',            year: '2026', festival: 'Lễ Khai Mạc Yosakoi 2026'   },
    { src: 'next-event-2.jpg',           caption: 'Đêm Hội Ánh Sáng',       year: '2026', festival: 'Đêm Hội Ánh Sáng 2026'      },
    { src: 'next-event-3.jpg',           caption: 'Grand Parade',            year: '2026', festival: 'Grand Parade 2026'           },
    { src: 'blog-image-1.jpg',           caption: 'Văn Hoá Yosakoi',        year: '2025', festival: 'Yosakoi Festival 2025'       },
    { src: 'blog-image-2.jpg',           caption: 'Không Khí Lễ Hội',       year: '2025', festival: 'Yosakoi Festival 2025'       },
    { src: 'blog-image-3.jpg',           caption: 'Trang Phục Truyền Thống', year: '2025', festival: 'Grand Parade 2025'           },
    { src: 'news-image-1.jpg',           caption: 'Báo Chí & Truyền Thông', year: '2026', festival: 'Chung Kết Toàn Quốc 2026'   },
    { src: 'news-image-2.jpg',           caption: 'Khoảnh Khắc Đặc Biệt',  year: '2024', festival: 'Yosakoi Festival 2024'       },
    { src: 'about-us-content-image.jpg', caption: 'Hậu Trường',             year: '2024', festival: 'Yosakoi Festival 2024'       },
    { src: 'image-1.jpg',                caption: 'Biểu Diễn',              year: '2025', festival: 'Lễ Khai Mạc Yosakoi 2025'   },
    { src: 'hihi.jpg',                   caption: 'Thi Đấu',                year: '2026', festival: 'Chung Kết Toàn Quốc 2026'   },
    { src: 'testimonial.jpg',            caption: 'Chân Dung Vũ Công',      year: '2024', festival: 'Grand Parade 2024'           },
];

export const MEMBER_POOL = [
    { name: 'Nguyễn Thị Hoa',   role: 'Đội Trưởng', initials: 'TH' },
    { name: 'Trần Văn Nam',      role: 'Đội Phó',    initials: 'VN' },
    { name: 'Lê Thị Mai',       role: 'Biên Đạo',   initials: 'TM' },
    { name: 'Phạm Quốc Bảo',    role: 'Vũ Công',    initials: 'QB' },
    { name: 'Hoàng Thị Lan',    role: 'Vũ Công',    initials: 'TL' },
    { name: 'Vũ Minh Tuấn',     role: 'Nhạc Công',  initials: 'MT' },
    { name: 'Đặng Thị Thu',     role: 'Vũ Công',    initials: 'TT' },
    { name: 'Bùi Văn Hùng',     role: 'Hậu Cần',    initials: 'VH' },
    { name: 'Đinh Thị Ngọc',    role: 'Vũ Công',    initials: 'TN' },
    { name: 'Lý Thị Cẩm',      role: 'Trang Phục', initials: 'TC' },
    { name: 'Cao Văn Phúc',     role: 'Vũ Công',    initials: 'VP' },
    { name: 'Trương Thị Bích',  role: 'Vũ Công',    initials: 'TB' },
    { name: 'Ngô Minh Châu',    role: 'Vũ Công',    initials: 'MC' },
    { name: 'Dương Thị Tuyết',  role: 'Trang Phục', initials: 'TY' },
    { name: 'Phan Văn Đức',     role: 'Vũ Công',    initials: 'VD' },
    { name: 'Hồ Thị Linh',     role: 'Vũ Công',    initials: 'TL' },
];

export const VIDEO_POOL = [
    { id: 'YOUTUBE_ID_1', title: 'Biểu Diễn Khai Mạc 2025',  desc: 'Tiết mục khai màn tại Lễ hội Yosakoi toàn quốc 2025',   year: '2025', festival: 'Lễ Khai Mạc Yosakoi 2025'  },
    { id: 'YOUTUBE_ID_2', title: 'Grand Parade 2025',          desc: 'Màn trình diễn hoành tráng tại lễ diễu hành lớn 2025',  year: '2025', festival: 'Grand Parade 2025'          },
    { id: 'YOUTUBE_ID_3', title: 'Chung Kết Toàn Quốc 2025', desc: 'Tiết mục xuất sắc tại đêm chung kết Yosakoi toàn quốc', year: '2025', festival: 'Chung Kết Toàn Quốc 2025'  },
    { id: 'YOUTUBE_ID_4', title: 'Luyện Tập & Hậu Trường',   desc: 'Hành trình chuẩn bị và nỗ lực cho mùa lễ hội 2026',     year: '2026', festival: 'Lễ Khai Mạc Yosakoi 2026'  },
];

/* ── Location helpers ─────────────────────────────────────── */
const LOCATION_MAP = {
    vn: { country: 'Việt Nam',  flag: null   },
    jp: { country: 'Nhật Bản',  flag: '🇯🇵' },
    pj: { country: 'Project',   flag: '📁'   },
    th: { country: 'Thái Lan',  flag: '🇹🇭' },
    tw: { country: 'Đài Loan',  flag: '🇹🇼' },
    sg: { country: 'Singapore', flag: '🇸🇬' },
    kr: { country: 'Hàn Quốc',  flag: '🇰🇷' },
    br: { country: 'Brazil',    flag: '🇧🇷' },
    fr: { country: 'Pháp',      flag: '🇫🇷' },
    us: { country: 'Mỹ',        flag: '🇺🇸' },
    au: { country: 'Úc',        flag: '🇦🇺' },
};

function toInitials(name) {
    return (name || '').split(' ').filter(Boolean).map(w => w[0].toUpperCase()).slice(0, 2).join('');
}

export function augment(t, idx) {
    const [c1, c2] = PALETTE[idx % PALETTE.length];
    const loc = LOCATION_MAP[t.location] || { country: (t.location || '').toUpperCase(), flag: null };
    const photos  = Array.from({ length: 8 }, (_, j) => PHOTO_POOL[(idx * 3 + j) % PHOTO_POOL.length]);
    const videos  = Array.from({ length: 2 }, (_, j) => VIDEO_POOL[(idx + j) % VIDEO_POOL.length]);
    const members = Array.from({ length: 8 }, (_, j) => {
        const m = MEMBER_POOL[(idx * 2 + j) % MEMBER_POOL.length];
        const [mc1, mc2] = PALETTE[(idx + j) % PALETTE.length];
        return { ...m, gradient: `linear-gradient(135deg, ${mc1} 0%, ${mc2} 100%)` };
    });
    return {
        id:           t.id,
        slug:         t.slug || null,
        name:         t.name,
        name_kana:    (t.name_kana && t.name_kana.trim()) || null,
        avatar_url:      t.avatar_url,
        background_url:  t.background_url || null,
        desc:            t.short_description || '',
        city:         loc.country,
        location:     loc.country,
        flag:         loc.flag,
        contact:      (t.facebook_url || '').trim() || (t.instagram_url || '').trim(),
        established:  t.established_at ? new Date(t.established_at).getFullYear() : '—',
        facebook_url: t.facebook_url,
        instagram_url: t.instagram_url,
        initials:     toInitials(t.name),
        gradient:     `linear-gradient(135deg, ${c1} 0%, ${c2} 100%)`,
        color1:       c1,
        element:      t.element || null,
        photos,
        videos,
        members,
    };
}

/* ── Camera icon ─────────────────────────────────────────── */
const CamIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
        <circle cx="12" cy="13" r="4"/>
    </svg>
);

/* ── Component ────────────────────────────────────────────── */
class Teams extends Component {
    state = {
        selected: null, numCols: 6,
        selectedOversea: null, numColsOversea: 6,
        selectedProject: null, numColsProject: 6,
        vnTeams: [],
        overseaTeams: [],
        pjTeams: [],
        loading: true,
        activeSection: 'teams-sec-vn',
        crowns: {},             // team id -> { rank: 1|2|3, count }
    };
    gridRef        = createRef();
    gridRefOversea = createRef();
    gridRefProject = createRef();

    componentDidMount() {
        this.updateCols();
        this.resizeHandler = () => this.updateCols();
        window.addEventListener('resize', this.resizeHandler, { passive: true });

        // Top 3 teams by number of tagged pictures get a crown (ignored if it fails).
        rpc.fetchRawData('GetTeamRanking', { limit: 3 })
            .then(rows => {
                const crowns = {};
                (Array.isArray(rows) ? rows : [])
                    .filter(r => r.pic_count > 0)
                    .slice(0, 3)
                    .forEach((r, i) => { crowns[String(r.id)] = { rank: i + 1, count: r.pic_count }; });
                this.setState({ crowns });
            })
            .catch(() => {});

        rpc.fetchRawData('GetTeams', { page: 1, limit: 200 })
            .then(res => {
                const all = res.data || [];
                let vnIdx = 0, ovIdx = 0, pjIdx = 0;
                const vnTeams      = all.filter(t => t.location === 'vn').map(t => augment(t, vnIdx++));
                const overseaTeams = all.filter(t => t.location === 'jp').map(t => augment(t, ovIdx++));
                const pjTeams      = all.filter(t => t.location === 'pj').map(t => augment(t, pjIdx++));
                this.setState({ vnTeams, overseaTeams, pjTeams, loading: false });
            })
            .catch(() => this.setState({ loading: false }));
    }

    componentDidUpdate(_, prevState) {
        if (prevState.loading && !this.state.loading) {
            // Grids (esp. Project) only exist once data has loaded — measure now so
            // the expand-row slot lands after the correct row on every screen size.
            this.updateCols();
            this._sectionObserver = new IntersectionObserver(
                entries => entries.forEach(e => { if (e.isIntersecting) this.setState({ activeSection: e.target.id }); }),
                { rootMargin: '-70px 0px -55% 0px', threshold: 0 }
            );
            ['teams-sec-vn', 'teams-sec-oversea', 'teams-sec-project'].forEach(id => {
                const el = document.getElementById(id);
                if (el) this._sectionObserver.observe(el);
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this._sectionObserver) this._sectionObserver.disconnect();
    }

    updateCols = () => {
        if (this.gridRef.current) {
            const raw  = window.getComputedStyle(this.gridRef.current).gridTemplateColumns;
            const cols = raw.trim().split(/\s+/).length;
            if (cols !== this.state.numCols) this.setState({ numCols: cols });
        }
        if (this.gridRefOversea.current) {
            const raw  = window.getComputedStyle(this.gridRefOversea.current).gridTemplateColumns;
            const cols = raw.trim().split(/\s+/).length;
            if (cols !== this.state.numColsOversea) this.setState({ numColsOversea: cols });
        }
        if (this.gridRefProject.current) {
            const raw  = window.getComputedStyle(this.gridRefProject.current).gridTemplateColumns;
            const cols = raw.trim().split(/\s+/).length;
            if (cols !== this.state.numColsProject) this.setState({ numColsProject: cols });
        }
    };

    select        = (i) => this.setState(prev => ({ selected:        prev.selected        === i ? null : i }));
    selectOversea = (i) => this.setState(prev => ({ selectedOversea: prev.selectedOversea === i ? null : i }));
    selectProject = (i) => this.setState(prev => ({ selectedProject: prev.selectedProject === i ? null : i }));

    buildGrid(list, selected, numCols, onSelect, onClose) {
        const selectedRow = selected !== null ? Math.floor(selected / numCols) : -1;
        const items = [];

        list.forEach((t, i) => {
            const isSelected = selected === i;
            const crown      = this.state.crowns[String(t.id)];
            items.push(
                <div
                    key={`card-${t.id}`}
                    className={`team-card${isSelected ? ' team-card-selected' : ''}${crown ? ` team-card--top team-card--top-${crown.rank}` : ''}`}
                    onClick={() => onSelect(i)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && onSelect(i)}
                >
                    <div className="team-avatar-wrap" data-element={t.element || 'tho'}>
                        {crown && (
                            <span className="team-aura" aria-hidden="true">
                                <span className="team-aura-rays" />
                                <span className="team-aura-glow" />
                                <span className="team-aura-ring" />
                                <span className="team-aura-ring team-aura-ring--late" />
                                {[0, 1, 2, 3, 4].map(k => <span key={k} className={`team-aura-spark team-aura-spark--${k}`} />)}
                            </span>
                        )}
                        {t.avatar_url
                            ? <div className="team-avatar team-avatar-img">
                                <img src={s3(t.avatar_url)} alt={t.name} />
                              </div>
                            : <div className="team-avatar" style={{ background: t.gradient }}>
                                {t.flag
                                    ? <span className="team-avatar-flag">{t.flag}</span>
                                    : <span>{t.initials}</span>
                                }
                              </div>
                        }
                        {isSelected && <div className="team-selected-ring" />}
                        {crown && <Crown rank={crown.rank} count={crown.count} />}
                    </div>
                    <div className="team-card-name">{t.name}</div>
                    {t.name_kana && <div className="team-card-kana">{t.name_kana}</div>}
                    {t.flag && <div className="team-card-city">{t.city}</div>}
                </div>
            );

            const isEndOfRow = (i + 1) % numCols === 0 || i === list.length - 1;
            if (isEndOfRow) {
                const rowIdx  = Math.floor(i / numCols);
                const isOpen  = selectedRow === rowIdx;
                const rowTeam = isOpen ? list[selected] : null;

                items.push(
                    <div key={`slot-${rowIdx}`} className={`team-detail-slot${isOpen ? ' team-detail-open' : ''}`}>
                        <div
                            className="team-detail-inner"
                            data-element={rowTeam ? (rowTeam.element || 'tho') : undefined}
                            style={rowTeam ? {
                                backgroundImage: rowTeam.background_url ? `url(${s3(rowTeam.background_url)})` : undefined,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                boxShadow: `0 8px 48px ${rowTeam.color1}55, 0 2px 12px rgba(0,0,0,0.25)`,
                            } : undefined}
                        >
                            {rowTeam && (
                                <>
                                    <div className="team-detail-accent" />

                                    <div className="team-detail-avatar" style={{ background: rowTeam.avatar_url ? undefined : 'rgba(255,255,255,0.15)' }}>
                                        {rowTeam.avatar_url
                                            ? <img src={s3(rowTeam.avatar_url)} alt={rowTeam.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                            : rowTeam.flag
                                                ? <span className="team-avatar-flag team-avatar-flag-lg">{rowTeam.flag}</span>
                                                : <span>{rowTeam.initials}</span>
                                        }
                                    </div>

                                    <div className="team-detail-body">
                                        <span
                                            className="team-detail-badge"
                                            style={{
                                                background: 'rgba(255,255,255,0.13)',
                                                border: '1px solid rgba(255,255,255,0.32)',
                                                color: '#fff',
                                            }}
                                        >{rowTeam.city}</span>
                                        <h2 className="team-detail-name">{rowTeam.name}</h2>
                                        <p className="team-detail-desc" dangerouslySetInnerHTML={{ __html: rowTeam.desc }} />
                                        <div className="team-detail-meta">
                                            {rowTeam.established !== '—' && (
                                                <div className="tdm-row">
                                                    <span className="tdm-label">Thành lập</span>
                                                    <span className="tdm-value">{rowTeam.established}</span>
                                                </div>
                                            )}
                                            {rowTeam.contact && (
                                                <div className="tdm-row">
                                                    <span className="tdm-label">{(rowTeam.facebook_url || '').trim() ? 'Facebook' : 'Instagram'}</span>
                                                    <span className="tdm-value">
                                                        <a href={rowTeam.contact} target="_blank" rel="noopener noreferrer">
                                                            {rowTeam.contact}
                                                        </a>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <Link
                                            to={{ pathname: `/teams/${rowTeam.slug || rowTeam.id}`, state: { team: rowTeam } }}
                                            className="team-album-btn"
                                        >
                                            <CamIcon />
                                            Video &amp; Ảnh
                                        </Link>
                                    </div>

                                    <button
                                        className="team-detail-close"
                                        onClick={onClose}
                                        aria-label="Đóng"
                                    >✕</button>
                                </>
                            )}
                        </div>
                    </div>
                );
            }
        });

        return items;
    }

    scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.scrollY - 72;
        window.scrollTo({ top, behavior: 'smooth' });
    };

    render() {
        const { selected, numCols, selectedOversea, numColsOversea, selectedProject, numColsProject, vnTeams, overseaTeams, pjTeams, loading, activeSection } = this.state;

        const vnItems = this.buildGrid(
            vnTeams, selected, numCols,
            this.select,
            () => this.setState({ selected: null }),
        );

        const overseaItems = this.buildGrid(
            overseaTeams, selectedOversea, numColsOversea,
            this.selectOversea,
            () => this.setState({ selectedOversea: null }),
        );

        const projectItems = this.buildGrid(
            pjTeams, selectedProject, numColsProject,
            this.selectProject,
            () => this.setState({ selectedProject: null }),
        );

        return (
            <div className="teams-page">
                <PageMeta title="Yosakoi Teams" description="Các đội Yosakoi tham gia Vietnam Yosakoi Festival – giới thiệu, thành viên và hoạt động." url="/teams" />

                <div className="page-header team-page-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">YOSAKOI TEAMS</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                <div className="tmd-section-nav">
                    <div className="container">
                        <div className="tmd-section-nav-inner">
                            <div className="tmd-sec-nav-btn-group">
                            {[
                                { id: 'teams-sec-vn',      label: 'Team Việt Nam' },
                                { id: 'teams-sec-oversea', label: 'Team Quốc Tế' },
                                { id: 'teams-sec-project', label: 'Team Project' },
                            ].map(({ id, label }) => (
                                <div key={id} className={`tmd-nav-item${activeSection === id ? ' active' : ''}`}>
                                    <button
                                        className="tmd-sec-nav-btn"
                                        onClick={() => this.scrollToSection(id)}
                                    ><span className="tmd-btn-bg" /></button>
                                    <span className="tmd-btn-label">{label}</span>
                                </div>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Vietnam teams */}
                <div className="teams-section" id="teams-sec-vn">
                    <div className="container">
                        <div className="entry-title">
                            <p>CÁC ĐỘI THAM GIA</p>
                            <h2>CÁC TEAM VIỆT NAM</h2>
                        </div>
                        <div className="teams-grid" ref={this.gridRef}>
                            {loading
                                ? <SakuraOrbit label="Đang tải đội nhóm" />
                                : vnTeams.length > 0
                                    ? vnItems
                                    : <p className="teams-empty">Không load được thông tin.</p>
                            }
                        </div>
                    </div>
                </div>

                {/* Overseas teams */}
                {(loading || overseaTeams.length > 0) && <SakuraSep />}
                {(loading || overseaTeams.length > 0) && (
                    <div className="teams-section teams-section-oversea" id="teams-sec-oversea">
                        <div className="container">
                            <div className="entry-title">
                                <p>GIAO LƯU QUỐC TẾ</p>
                                <h2>TEAM ĐÃ TỪNG ĐẾN VIỆT NAM</h2>
                            </div>
                            <div className="teams-grid" ref={this.gridRefOversea}>
                                {loading
                                    ? <SakuraOrbit label="Đang tải đội nhóm" />
                                    : overseaItems
                                }
                            </div>
                        </div>
                    </div>
                )}

                {/* Project teams */}
                {!loading && pjTeams.length > 0 && <SakuraSep />}
                {!loading && pjTeams.length > 0 && (
                    <div className="teams-section teams-section-project" id="teams-sec-project">
                        <div className="container">
                            <div className="entry-title">
                                <p>NHỮNG MÀN TRÌNH DIỄN ĐẶC BIỆT</p>
                                <h2>TEAM PROJECT</h2>
                            </div>
                            <div className="teams-grid" ref={this.gridRefProject}>
                                {projectItems}
                            </div>
                        </div>
                    </div>
                )}

                <SakuraSep />
                <div className="sep-gold-rule" style={{margin: 0}} />

            </div>
        );
    }
}

export default Teams;
